export function color(_ref:any) {
    var zeroColor = '#cccccc';
    var lowColor = '#10EE10';
    var mediumColor = '#CCCC33';
    var highColor = '#CC1010';
    var severity = _ref.severity;
    if (severity===0) {
      return zeroColor;
    }
    if (severity < 5 && severity > 0) {
      return lowColor;
    }
    if (severity >= 5 && severity < 8) {
      return mediumColor;
    }
    if (severity >= 8) {
      return highColor;
    }
      return zeroColor;
  }